import BlockArticleHorizontal from './BlockArticleHorizontal';
export default BlockArticleHorizontal;
